module.exports = __webpack_public_path__ + "static/media/marketing-sales-icon.d5478c6e.svg";